import useAuthStore from "views/hooks/useAuthStore";

export function usePermissions() {
  const userData = useAuthStore(state => state.userData);

  const hasPermission = (permission: string) =>
    !!userData?.permissions.some((item: string) => item === permission);

  const canExport = hasPermission("central-api.can-export");

  const canUpdateCompany = hasPermission("dashboard.can-display-companies");

  const canViewPaymentMethods = hasPermission("central-api.can-view-payment-methods");

  const canViewMostUsedCounterparts = hasPermission("neossi-api.can-view-most-used-counterparts");

  const isDemoClient =
    !userData?.isSuperuser && hasPermission("neoauth.is-client-without-accounting");

  return {
    canExport,
    canUpdateCompany,
    canViewPaymentMethods,
    canViewMostUsedCounterparts,
    isDemoClient,
  };
}
